import { useContext, useEffect, useState } from "react";
import { EditorContext } from "./../../ricos-context";
const useEditorSelection = (editor) => {
  const { getEditorCommands } = useContext(EditorContext);
  const [selection, setSelection] = useState(
    () => getEditorCommands().getSelection()
  );
  useEffect(() => {
    const onSelectionUpdate = () => {
      setSelection(getEditorCommands().getSelection());
    };
    editor.on("selectionUpdate", onSelectionUpdate);
    return () => {
      editor.off("selectionUpdate", onSelectionUpdate);
    };
  }, []);
  return selection;
};
export {
  useEditorSelection
};
//# sourceMappingURL=use-editor-selection.js.map
